import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MapInitialState, MapStateTypes } from 'store/map/map.state.ts';
import { fetchMapLayerID } from 'store/map/map.thunk.ts';
const initialState: MapStateTypes = MapInitialState;

export const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    updateMapInfo: (state, action: PayloadAction<{ [key: string]: string | boolean }>) => {
      state.mapInfo = { ...state.mapInfo, ...action.payload };
    },
    // `mapInfo` holds group-scoped settings (mapId, mapSettingsID) resolved for
    // the signed-in user's group, so it is session state rather than device
    // state and is cleared with the session.
    resetMap: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMapLayerID.fulfilled, (state, action) => {
      const payloadData = action.payload;
      if (Array.isArray(payloadData) && payloadData.length > 0) {
        const data = payloadData[0];
        state.mapInfo.mapId = data.pvSettingValue;
        state.mapInfo.mapSettingsID = data.pvSettingID;
      }
    });
  },
});

export default mapSlice.reducer;
